import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var createVisitSlice = createSlice({
    name: "createVisit",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _createVisitSlice_actions = createVisitSlice.actions;
export var fetchData = _createVisitSlice_actions.fetchData, fetchDataSuccess = _createVisitSlice_actions.fetchDataSuccess, fetchDataFailure = _createVisitSlice_actions.fetchDataFailure, resetState = _createVisitSlice_actions.resetState;
export default createVisitSlice.reducer;
